var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "heavy-last-grid-item",
    attrs: {
      "id": _vm.getId + '-wrapper'
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('short-text-filter', {
    ref: "biomaterial_search_input",
    staticClass: "raft-js-search-add-label",
    attrs: {
      "id": _vm.getId + '-filter',
      "styled-label": "Name",
      "update-method": _vm.updateSearch,
      "use-json-api-filter-manager": false,
      "placeholder": "Enter search terms",
      "help-text": "Enter at least two characters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-block text-center capped-search-results-height",
    attrs: {
      "id": "raft-bio-search-add"
    }
  }, [_vm.response && _vm.totalMaterials === 0 ? _c('div', [_vm._v("\n      No biological materials were found.\n    ")]) : _vm._e(), _vm._v(" "), _c('b-form', {
    attrs: {
      "id": "raft-bio-mat-search-add-from-library"
    }
  }, [_c('b-radio-group', [_vm.isReady ? _c('div', {
    staticClass: "raft-bio-mat-search-results-wrapper",
    attrs: {
      "id": "raft-bio-search-add-results"
    }
  }, [_vm._l(_vm.bioMaterials, function (bioMat, index) {
    return _c('div', {
      key: bioMat.id,
      staticClass: "raft-bio-mat-search-result",
      class: {
        'raft-bio-mat-odd': index % 2
      },
      on: {
        "click": function ($event) {
          _vm.selectedBioMaterial = bioMat;
        }
      }
    }, [_c('b-form-radio', {
      staticClass: "raft-bio-mat-radio",
      attrs: {
        "id": 'search-result-radio-' + bioMat.drupal_internal__id.toString(),
        "value": bioMat
      },
      model: {
        value: _vm.selectedBioMaterial,
        callback: function ($$v) {
          _vm.selectedBioMaterial = $$v;
        },
        expression: "selectedBioMaterial"
      }
    }, [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n                Select " + _vm._s(bioMat.name) + " with ID\n                " + _vm._s(bioMat.drupal_internal__id) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "raft-bio-mat-search-result-data"
    }, [_c('BioMaterialRender', {
      attrs: {
        "bio-material": bioMat,
        "display-field-data": _vm.displayData
      }
    })], 1)], 1);
  }), _vm._v(" "), _c('div', [_vm.totalMaterials > _vm.resultsPerPage ? _c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalMaterials,
      "per-page": _vm.resultsPerPage,
      "limit": "10",
      "first-text": "« first",
      "prev-text": "‹ previous",
      "next-text": "next ›",
      "last-text": "last »",
      "align": "center"
    },
    on: {
      "change": _vm.updateCurrentPage
    }
  }) : _vm._e()], 1)], 2) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "raft-bio-mat-search-result-actions",
    attrs: {
      "data-testid": "copyFromLibrary"
    }
  }, [_c('div', {
    staticClass: "raft-bio-mat-footer-left"
  }, [_c('div', {
    staticClass: "raft-bio-mat-search-result-add-new"
  }, [_c('h3', [_vm._v("No matches?")]), _vm._v(" "), !_vm.isBusy ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.addMaterialStub.apply(null, arguments);
      }
    }
  }, [_vm._v("\n          Enter new " + _vm._s(_vm.lowerCasedLabel) + " manually\n        ")]) : _vm._e()]), _vm._v(" "), _vm.showBackButton ? _c('a', {
    attrs: {
      "href": "",
      "data-testid": "back"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.backToMaterialTypeSelect.apply(null, arguments);
      }
    }
  }, [_vm._v("Back")]) : _vm._e()]), _vm._v(" "), !_vm.isBusy ? _c('VButton', {
    class: _vm.buttonStyle,
    on: {
      "click": function ($event) {
        return _vm.addToLibrarySelected(_vm.selectedBioMaterial, true);
      }
    }
  }, [_vm._v("Select from Library")]) : _vm._e(), _vm._v(" "), _vm.isBusy ? _c('raft-busy', {
    attrs: {
      "busy-text": "Adding to group"
    }
  }) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }